<template>
    <b-card>
        <ContentOrLoading>
            <div v-if="posiciones" class="table-responsive">
                <b-table v-if="!loading" hover :items="posiciones" :fields="fields"/>
            </div>
        </ContentOrLoading>
    </b-card>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                posiciones: null,
                fields: [
                    { key: "id", label: "ID" },
                    { key: "nombre", label: "Nombre" }
                ],
            }
        },
        created() {
            this.getPosiciones();
        },
        methods: {
            getPosiciones() {
                this.loading = true;

                const params = {
                    teatro_id: this.teatro.id,
                    filters : {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.posiciones.index'), params).then(res => {
                    this.posiciones = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>
